/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

function linearGradient(color, colorState, angle = 0) {
  return `linear-gradient(${angle}deg, ${color}, ${colorState})`;
}

export default linearGradient;
